// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { BaseResponseZendeskConfigTicketFoundResponse } from '../../types';

/**
 * get
 *
 * @export
 * @tags zendesk-config-ticket-controller
 * @link [GET] /zendeskConfigs/ticket
 */
export function getZendeskConfigsTicket(): Promise<BaseResponseZendeskConfigTicketFoundResponse>;
export function getZendeskConfigsTicket(
    options: ApiOptions<never, never>
): Promise<BaseResponseZendeskConfigTicketFoundResponse>;
export function getZendeskConfigsTicket(
    options?: ApiOptions<never, never>
): Promise<BaseResponseZendeskConfigTicketFoundResponse> {
    return request<never, never, never>('/zendeskConfigs/ticket', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getZendeskConfigsTicket',
    });
}

export const meta = [
    { tags: ['zendesk-config-ticket-controller'], path: '/zendeskConfigs/ticket', method: 'get' },
];
